import api from '../../api/acf-options';

export default {
    state: {
        acfOptions: {},
    },

    mutations: {
        setOptions(state, data) {
            state.acfOptions = data;
        },
    },

    actions: {
        fetchModuleData() {
            this.dispatch('fetchOptions');
        },
        fetchOptions({ commit }) {
            return new Promise((resolve) => {
                api.get()
                    .then((response) => {
                        commit('setOptions', response.data.acf);
                        resolve();
                    });
            });
        },
    },

    getters: {
        getAcfOptionField(state) {
            return (field) => {
                if ( state.acfOptions && state.acfOptions.hasOwnProperty(field)) {
                    return state.acfOptions[field];
                }
                return null;
            };
        }
    }
};